<template>
  <div class="scene-medium-menu">
    <item-header
      :label="$t('objectNames.medium')"
      @close="$emit('close')"
    >
      <template #content>
        <editable-item-title :item="ctx.sceneNode" />
      </template>
    </item-header>

    <!-- DESIGN -->
    <drawer
      :title="$t('labels.design')"
      v-model:open="drawerStates.mediumDesign"
    >
      <div class="column gap-4">
        <div>
          <div class="label input__label">
            {{ $t("words.image") }}
          </div>
          <input-image-zone
            :image-data="mediumData"
            @delete="deleteImage"
            @change="overrideMedium($event)"
          />
        </div>

        <div class="column gap-1">
          <input-switch
            :value="ctx.sceneNode.aspectRatioLocked"
            @update:value="ctx.updateKey('aspectRatioLocked', $event)"
          >
            {{ $t("labels.aspectRatioFixed") }}
          </input-switch>

          <input-switch
            :value="ctx.sceneNode.visible"
            @update:value="ctx.updateKey('visible', $event)"
          >
            {{ $t("labels.visible") }}
          </input-switch>
        </div>
      </div>
    </drawer>

    <!-- DELETE -->
    <menu-group class="mt-auto">
      <button
        type="button"
        class="button button_secondary mv-2"
        @click="ctx.delete()"
      >
        {{ $t("actions.deleteMedium", 1) }}
      </button>
    </menu-group>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useSceneMedium } from './useSceneMedium';
import { useSceneMediumStore } from './sceneMedia.store';
import { useDrawerStates } from '@editor/store/editor/drawerStates.store';

import EditableItemTitle from '@editor/components/EditableItemTitle.vue';
import ItemHeader from '@editor/components/ItemHeader.vue';
import InputImageZone from '@core/input/InputImageZone.vue';
import Drawer from '@core/ui/DrawerBlock.vue';
import InputSwitch from '@core/input/InputSwitch.vue';
import MenuGroup from '@core/ui/MenuGroup.vue';
import type { Uid } from '@/helpers/utility/Id';

const props = defineProps<{
  nodeUid: Uid<"sceneNode">;
}>();

const ctx = useSceneMedium(() => props.nodeUid);
const drawerStates = useDrawerStates();
const store = useSceneMediumStore();

const mediumData = computed(() => {
  return store.mediaData[props.nodeUid] ?? undefined;
});

function overrideMedium(image: { src: string; width: number; height: number; type: string }) {
  const width = ctx.sceneNode.width;
  const aspectRatio = image.width / image.height;
  const newHeight = width / aspectRatio;

  ctx.update({
    data: {
      data: image.src,
      mediaType: image.type,
    },
    height: newHeight
  });
}

function deleteImage() {
  store.clearMediumData({ id: ctx.sceneNode.id });
}
</script>

<style lang="scss">
.scene-medium-menu {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>